import { render, staticRenderFns } from "./profile-suspension-info.vue?vue&type=template&id=75696006&scoped=true"
import script from "./profile-suspension-info.vue?vue&type=script&lang=js"
export * from "./profile-suspension-info.vue?vue&type=script&lang=js"
import style0 from "./profile-suspension-info.vue?vue&type=style&index=0&id=75696006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75696006",
  null
  
)

export default component.exports